import { ModalsSlice } from '@hefe/store';
import { Modal } from 'antd';
import React, { useState } from 'react';
import { useAppDispatch } from '../../../../store/store';
import CustomTable, {
  CustomTableProps,
} from '../../../core/components/table/custom-table.component';

interface CRUDComponentProps {
  table: CustomTableProps;
  updateComponent: {
    component: any;
    propKey: string;
    title?: string;
    titleKey?: string;
    formId?: string;
    width?: number;
    disabled?: (item: any) => boolean;
  };
  delete?: {
    action: any;
    multiDelete: boolean;
    text?: string;
  };
}

export default function CRUDComponent(props: CRUDComponentProps) {
  const dispatch = useAppDispatch();

  const [deleting, setDeleting] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>();
  const [selectedKeys, setSelectedKeys] = useState<any[]>([]);

  const onTableRowClick = (item: any) => {
    if (props.updateComponent.formId) {
      const updateProps: any = {};
      updateProps[props.updateComponent.propKey] = item;
      UpdateComponent = <props.updateComponent.component {...updateProps} />;

      dispatch(
        ModalsSlice.modalsActions.openModal({
          component: UpdateComponent,
          title: props.updateComponent.titleKey
            ? item[props.updateComponent.titleKey]
            : props.updateComponent.title || '',
          formId: `${props.updateComponent.formId}-${item[props.table.rowKey]}`,
        })
      );
    } else {
      setSelectedRow(item);
    }
  };

  const onDelete = (ids: any[]) => {
    setDeleting(true);

    if (props.delete) {
      let data = props.table.dataSource.find(
        (item) => item[props.table.rowKey] === ids[0]
      );
      if (props.delete.multiDelete) {
        data = ids;
      }

      if (data) {
        dispatch(props.delete.action(data))
          .unwrap()
          .catch(() => null)
          .finally(() => setDeleting(false));
      }
    }
  };

  let UpdateComponent: any;
  let title = '';

  if (props.updateComponent && selectedRow) {
    const updateProps: any = {};
    updateProps[props.updateComponent.propKey] = selectedRow;
    UpdateComponent = <props.updateComponent.component {...updateProps} />;
    title = props.updateComponent.titleKey
      ? selectedRow[props.updateComponent.titleKey]
      : props.updateComponent.title || '';
  }

  let deleteAction;
  if (props.delete) {
    deleteAction = {
      action: (ids: any[]) => onDelete(ids),
      loading: deleting,
      multiDelete: props.delete.multiDelete,
      text: props.delete.text,
    };
  }

  return (
    <div>
      <CustomTable
        {...props.table}
        onRowClick={(item: any) => {
          if (props.updateComponent.disabled) {
            if (props.updateComponent.disabled(item)) {
              return undefined;
            }
          }

          onTableRowClick(item);
        }}
        deleteAction={deleteAction}
      />
      <Modal
        title={title}
        open={!!selectedRow}
        onOk={() => setSelectedRow(undefined)}
        onCancel={() => setSelectedRow(undefined)}
        cancelButtonProps={{ hidden: true }}
        width={props.updateComponent.width}
        zIndex={1}
      >
        {UpdateComponent}
      </Modal>
    </div>
  );
}
